import Modal from '../helpers/Modal';
import Order from '../helpers/Order';

export default class CartModal {
    constructor(root) {
        this.root = root;

        this.item_container = this.root.querySelector('.js-cart-modal-item-container');

        this.coupon_button = this.root.querySelector('.js-cart-modal-coupon-btn');
        this.coupon_area = this.root.querySelector('.js-cart-modal-coupon-area');
        this.coupon_field = this.root.querySelector('.js-cart-modal-coupon-field');
        this.coupon_submit = this.root.querySelector('.js-cart-modal-coupon-submit');

        this.view_order_buttons = this.root.querySelectorAll('.js-cart-modal-view-order');
        this.try_again_button = this.root.querySelector('.js-cart-modal-try-again');
        this.guest_checkout_button = this.root.querySelector('.js-cart-modal-guest-checkout');

        this.checkout_button = this.root.querySelector('.js-cart-modal-checkout');
        this.steps = {
            1: this.root.querySelector('.js-cart-modal-step-1'),
            2: this.root.querySelector('.js-cart-modal-step-2'),
            3: this.root.querySelector('.js-cart-modal-step-3'),
            4: this.root.querySelector('.js-cart-modal-step-4'),
            5: this.root.querySelector('.js-cart-modal-step-5'),
            6: this.root.querySelector('.js-cart-modal-step-6'),
            7: this.root.querySelector('.js-cart-modal-step-7'),
        };

        this.paypal_container = this.root.querySelector('.js-cart-paypal-container');

        this.cart_total = this.root.querySelector('.js-cart-modal-total');

        this.coupon_button.addEventListener('click', (event) => {
            event.preventDefault();
            this.coupon_area.classList.add('--active');
            this.coupon_field.focus();
        });

        this.try_again_button.addEventListener('click', (event) => {
            this.showStep(1);
        });

        this.guest_checkout_button.addEventListener('click', (event) => {
            event.preventDefault();
            this.determineCheckoutRoute();
        });

        this.coupon_field.addEventListener('input', (event) => {
            event.target.value = event.target.value.toUpperCase();
        });

        this.coupon_area.addEventListener('mouseleave', () => {
            this.coupon_area.classList.remove('--active');
        });

        this.coupon_submit.addEventListener('click', (event) => {
            event.preventDefault();

            if(!window.theme.cart.hasItem(this.coupon_field.value)) {
                window.theme.cart.add(this.coupon_field.value);
                this.update();
            }
        });

        window.addEventListener('user-data-received', (event) => {
            this.update();
        });

        window.addEventListener('user-data-removed', (event) => {
            this.update();
        });

        this.checkout_button.addEventListener('click', (event) => {
            event.preventDefault();

            //stop checking for updates
            clearInterval(this.refresh_interval);
            this.refresh_interval = null;

            if(!window.current_user) {
                this.showStep(2);
            } else {
                this.determineCheckoutRoute();
            }
        });

        this.modal = new Modal(this.root, (dataset) => {
            setTimeout(() => {
                this.root.classList.add('--fade-in-up');
                this.root.classList.remove('--fade-in-left', '--fade-out-right');
            }, 1000);

            //update the cart
            this.update();

            //update the cart every minute when open
            this.refresh_interval = setInterval(() => {
                this.update();
            }, 60000);
        },
        () => {
            clearInterval(this.refresh_interval);
            this.refresh_interval = null;

            this.showStep(1);
        });
    }

    determineCheckoutRoute() {
        if(window.theme.cart.latest_data.total.raw == 0) {
            let cart_data = window.theme.cart.latest_data;

            new Order({
                paypal: null,
                cart: cart_data
            }, (data) => {
                this.updateViewOrderButtons(data);
                
                let types = window.theme.cart.latest_data.items.map(obj => obj.type);
                let titles = window.theme.cart.latest_data.items.map(obj => obj.title);

                if(cart_data.total.raw == 0 && types.every(obj => obj === 'ticket' || obj === 'coupon')) {
                    this.showStep(6); //show RSVP success
                } else if(types.every(obj => obj === 'product' || obj === 'fee') && titles.every(obj => obj.toLowerCase().includes('raffle'))) {
                    let code_area = this.root.querySelector('.js-cart-modal-purchase-code');
                    code_area.innerHTML = data.slice(-4).toUpperCase();
                    this.showStep(7); //show raffle success
                } else {
                    this.showStep(4); //show order success
                }

                window.theme.cart.clear();
                window.dispatchEvent(new Event('cart-changed'));
            });
        } else {
            this.showStep(3);
            this.checkout();
        }
    }

    showStep(step_num) {
        for(let step in this.steps) {
            if(step == step_num) {
                this.steps[step].classList.remove('--hidden');
            } else {
                this.steps[step].classList.add('--hidden');
            }
        }
    }

    update() {
        this.has_errors = false;

        window.theme.cart.request((cart_data) => {
            this.cart_total.innerText = cart_data.total.formatted;
            this.item_container.innerHTML = '';

            cart_data.items.forEach((item) => {
                if(item.type) {
                    this.item_container.insertAdjacentHTML('beforeend', this.makeItem(item));

                    this.getElement('.js-cart-modal-edit-item', item.id)?.addEventListener('click', (event) => {
                        event.preventDefault();

                        this.editItem(item);
                    });

                    this.getElement('.js-cart-modal-delete-item', item.id)?.addEventListener('click', (event) => {
                        event.preventDefault();

                        window.theme.cart.remove(item.id, null, true);

                        this.update();

                        //push a cart change event
                        window.dispatchEvent(new Event('cart-changed'));
                    });
                }
            });

            if(this.has_errors || window.theme.cart.isEmpty()) {
                this.checkout_button.classList.add('--disabled');
            } else {
                this.checkout_button.classList.remove('--disabled');
            }
        });
    }

    makeItem(item_data) {
        let error_class = (item_data.errors.length != 0 ? '--has-errors' : null);

        let subtitle = item_data.label;

        if(item_data.subtitle) {
            if(subtitle != '') {
                subtitle += ' • ' + item_data.subtitle;
            } else {
                subtitle += item_data.subtitle;
            }
        }

        let edit_button = '';
        let delete_button = '';

        if(item_data.permalink) {
            edit_button = `<a class="modal-cart__main__item-meta__options__button-link js-cart-modal-edit-item" data-id="${item_data.id}" href="#"><img class="modal-cart__main__item-meta__options__button-icon" src="${window.theme.variables.assets_url}/icons/edit-white.svg"/></a>`;
        }

        if(item_data.type != 'fee') {
            delete_button = `<a class="modal-cart__main__item-meta__options__button-link js-cart-modal-delete-item" data-id="${item_data.id}" href="#"><img class="modal-cart__main__item-meta__options__button-icon" src="${window.theme.variables.assets_url}/icons/delete-white.svg"/></a>`;
        }

        return `
            <div class="modal-cart__main__item-group js-cart-modal-cart-group ${error_class}">
                <div class="modal-cart__main__item-meta">
                    <p class="modal-cart__main__item-meta__price js-cart-modal-ticket-total">${item_data.price.combined.formatted}</p>
                    <div class="modal-cart__main__item-meta__details">
                        <p class="modal-cart__main__item-meta__details__subtitle">${subtitle}</p>
                        <p class="modal-cart__main__item-meta__details__title">${item_data.title}</p>
                    </div>
                    <div class="modal-cart__main__item-meta__options">
                        ` + edit_button + `
                        ` + delete_button + `
                    </div>
                </div>
                ` + this.makeItemErrors(item_data) + `
            </div>
        `;
    }

    makeItemErrors(item_data) {
        let return_content = '';

        if(item_data.errors.length > 0) {
            this.has_errors = true;
        }

        if(item_data.errors.length > 0 || item_data.warnings.length > 0) {
            return_content = `
            <div class="modal-cart__main__error-container">
                <ul class="modal-cart__main__errors">`;

            item_data.errors.forEach((error) => {
                return_content += `<li class="modal-cart__main__error">${error}</li>`;
            });

            item_data.warnings.forEach((warning) => {
                return_content += `<li class="modal-cart__main__error --info">${warning}</li>`;
            });

            return_content += `
                </ul>
            </div>
            `;
        }

        return return_content;
    }

    editItem(item_data) {
        if(item_data.type == 'ticket') {
            let url = new URL(item_data.permalink);

            if(window.location.pathname == url.pathname) {
                this.root.classList.add('--fade-out-right');
                this.root.classList.remove('--fade-in-left', '--fade-in-up');

                let ticket_modal = this.modal.getModal('ticket');
                ticket_modal.root.classList.add('--fade-in-left');
                ticket_modal.root.classList.remove('--fade-out-right', '--fade-in-up');

                setTimeout(() => {
                    this.modal.openAnotherModal('ticket');
                }, 500);
            } else {
                window.location.href = item_data.permalink + '?mdl=ticket';
            }
        }
    }

    getElement(class_name, id, dataset_variable = 'id') {
        return this.root.querySelector(class_name + '[data-' + dataset_variable + '="' + id + '"]');
    }

    getElements(class_name, id, dataset_variable = 'id') {
        return this.root.querySelectorAll(class_name + '[data-' + dataset_variable + '="' + id + '"]');
    }

    updateViewOrderButtons(data) {
        this.view_order_buttons.forEach((view_order_button) => {
            view_order_button.setAttribute('href', window.theme.variables.orders_url_unformatted + `&o=${data}`);

            //hide/show the button depending on login state
            if(!window.current_user) {
                view_order_button.classList.add('--hidden');
            } else {
                view_order_button.classList.remove('--hidden');
            }
        });
    }

    checkout() {
        let cart_data = window.theme.cart.latest_data;

        this.paypal_container.innerHTML = '';

        const paypalButtonsComponent = paypal.Buttons({
            // optional styling for buttons
            // https://developer.paypal.com/docs/checkout/standard/customize/buttons-style-guide/
            style: {
                color: "blue",
                shape: "pill",
                layout: "vertical",
            },

            // set up the transaction
            createOrder: (data, actions) => {
                let cart_items = [];
                let coupon_amount = 0;
                
                cart_data.items.forEach((item) => {
                    let title = item.title;

                    if(item.subtitle) {
                        title += ' | ' + item.subtitle;
                    }

                    let item_obj = {
                        name: title,
                        sku: item.id.substring(item.id.length - 12),
                        unit_amount: {
                            value: item.price.raw,
                            currency_code: 'USD'
                        },
                        quantity: item.count
                    };

                    if(item.type == 'coupon') {
                        coupon_amount += item.price.raw;
                        item_obj.unit_amount.value = 0;
                    }

                    cart_items.push(item_obj);
                });

                // pass in any options from the v2 orders create call:
                // https://developer.paypal.com/api/orders/v2/#orders-create-request-body
                return actions.order.create({ 
                    purchase_units: [{
                        amount: {
                            value: cart_data.total.raw,
                            currency_code: 'USD',
                            breakdown: {
                                item_total: {
                                    value: cart_data.total.raw - coupon_amount,
                                    currency_code: 'USD'
                                },
                                discount: {
                                    value: coupon_amount * -1,
                                    currency_code: 'USD'
                                }
                            }
                        },
                        items: cart_items
                    }]
                });
            },

            // finalize the transaction
            onApprove: (data, actions) => {
                return actions.order.capture().then((details) => {
                    new Order({
                        paypal: details,
                        cart: cart_data
                    }, (data) => {
                        this.updateViewOrderButtons(data);

                        let types = window.theme.cart.latest_data.items.map(obj => obj.type);
                        let titles = window.theme.cart.latest_data.items.map(obj => obj.title);

                        if(types.every(obj => obj === 'product' || obj === 'fee') && titles.every(obj => obj.toLowerCase().includes('raffle') || obj.toLowerCase().includes('fee'))) {
                            let code_area = this.root.querySelector('.js-cart-modal-purchase-code');
                            code_area.innerHTML = data.slice(-4).toUpperCase();
                            this.showStep(7); //show raffle success
                        } else {
                            this.showStep(4);
                        }

                        window.theme.cart.clear();
                        window.dispatchEvent(new Event('cart-changed'));
                    });
                });
            },

            // handle unrecoverable errors
            onError: (err) => {
                this.showStep(5);
                console.error('An error prevented the buyer from checking out with PayPal');
            }
        });

        paypalButtonsComponent.render(this.paypal_container)
        .catch((err) => {
            this.showStep(5);
            console.error('PayPal Buttons failed to render');
        });
    }
}
